var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-widget__info order-widget__info--slots" },
    [
      _c("span", { staticClass: "order-widget__days" }, [
        _c("i", { staticClass: "fas fa-infinity" }),
        _vm._v(
          " " +
            _vm._s(_vm.i18n.t("general:non_special_texts.slot_plural")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "order-widget__slots" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.units) +
            " " +
            _vm._s(_vm.i18n.t(_vm.cloudUnitType.loco_key)) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "order-widget__price" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.i18n.t("landingpage:orderwidget.ram_price_per_day", {
                formattedPrice: _vm.formattedPrice,
                duration: _vm.duration,
              })
            ) +
            "\n  "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }